import { lazy } from "react";

/**
 * CountyConfigProvider, loaded on demand.
 *
 * The provider module statically imports the whole CIE registry: every
 * county and state config plus the national subject-identity tables, about
 * 700 KB of source before minification. Any entry-chunk module that imports
 * it statically puts all of that on every page's critical path, including the
 * marketing homepage, which never reads a county config. Entry-chunk callers
 * (the router and the route wrappers) render this instead, inside an existing
 * <Suspense> boundary. It resolves to the same module as every other importer,
 * so the context object and the hooks stay shared.
 *
 * scripts/ci/entry-chunk-weight-scan.mjs fails the build if the registry
 * finds its way back into the entry chunk.
 */
export const LazyCountyConfigProvider = lazy(() =>
  import("./CountyConfigProvider").then((m) => ({ default: m.CountyConfigProvider })),
);
